import React from 'react';
import { Target, Globe, Award, Zap } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  Target: Target,
  Globe: Globe,
  Award: Award,
  Zap: Zap
};

const Stats = () => {
  const { stats } = mockData;

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = iconMap[stat.icon];
            return (
              <div
                key={index}
                className="text-center group hover:transform hover:scale-105 transition-all duration-300 bg-white p-6 rounded-2xl shadow-sm hover:shadow-xl"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-2xl mb-4 group-hover:bg-blue-600 transition-colors duration-300">
                  <Icon className="w-8 h-8 text-blue-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <div className="text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
                <div className="text-sm font-semibold text-gray-900 mb-1">{stat.label}</div>
                <div className="text-xs text-gray-500">{stat.sublabel}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stats;